import Vue from 'vue'
import Vuex from 'vuex'
import Constant from '@/const.js'

Vue.use(Vuex)

export default new Vuex.Store({

  /**
    * States
    */
    state: {
      env : {} ,
      node_env : "" , 
      device : {} , 
      // main theme
      theme : '' , 
      window : {} , 
      // main constant of project
      const: Constant , 
      // object containg all configurations of each dataviz (see main.js file or each json file in conf/)
      conf: {} , 

      // specific version driven by folder (see participating states)
      version: null , 
      ps : false , 
      
      filters : {} , 
      extra_tabs : {} , 
      graphic : { title : '' , footnote : '' },

      api : '', // the full rest api url after binding version number

      // dictionnary, preload once to be used accross a website (see DatavizFilters or Database/Dictionnary page)
      dictionnary : {
        cancers : [] ,
        populations : [] , 
        populations_groupings : {
          'hdi' : [] , 
          'who' : [] , 
          'income' : [] , 
          'continents' : [] , 
          'regions' : [] , 
          'gicr_hubs' : []
        }
      },

    },

    /**
    * Mutations
    */
    mutations: {
      setEnv (state,env) {
          state.env = env
          state.node_env = env.NODE_ENV ; 
      },
      setConst (state,const_) {
          state.const = const_
      },
      setConf(state,conf){
        state.conf = conf 
      },
      setVersion(state,version){
        state.version = version 
        state.ps = ( version == '2022ps') ; 
      },
      setWindow (state,window_) {
          state.window = window_
      },
      setDevice (state,device) {
          state.device = device
      },
      setDictionnay(state,dictionnary){
        state.dictionnary = dictionnary 
      },
      setFilters(state,filters){
        state.filters = filters 
      },
      setExtraTabs(state,extra_tabs){
        state.extra_tabs = extra_tabs 
      },
      setGraphic(state,graphic){
        state.graphic = graphic 
      },
      setApi(state,api){
        state.api = api 
      },
      setDictionnay(state,dictionnary){

        // some hardcoded renaming
        dictionnary.cancers_promise = dictionnary.cancers_promise
          /*.filter( c => {
            return !state.const.all_cancers_ids_list.includes(c.cancer_code) 
          })*/
          .map( c => {

            let short_cancers_sites_labels = [
              { cancer : 11 , short_label : 'Liver' } ,
              { cancer : 15 , short_label : 'Lung' } ,
              { cancer : 16 , short_label : 'Melanoma' , factsheet_long : true} ,
              { cancer : 31 , short_label : 'Brain CNS' } ,
              { cancer : 34 , short_label : 'NHL' , factsheet_long : true } ,
              { cancer : 17 , short_label : 'NMSC' , factsheet_long : true} ,
              { cancer : 29 , short_label : 'Kidney' } ,
              { cancer : 35 , short_label : 'Multiple myeloma' } ,
              { cancer : 40 , short_label : 'All cancers excl. NMSC' }
            ] ; 

            let expt = short_cancers_sites_labels.find( s => s.cancer == c.cancer ) ; 

            if ( expt == undefined ){
              c.short_label = c.label ;
            }
            else {
              c.short_label = expt.short_label ;
              c.factsheet_long = ( expt.factsheet_long == true ) ;
            }

            return c ; 
          })
          .sort( (a,b) => a.label.toUpperCase() > b.label.toUpperCase() )
        
        // console.info("dictionnary.cancers_promise",dictionnary.cancers_promise) ; 
        /*dictionnary.cancers_promise.push({
          "id": 41,
          "cancer": 41,
          "label": "Colorectum",
          "short_label": "Colorectum",
          "ICD": "C-18-21",
          "gender": 0,
          "color": "#ffd803",
          "cancer_order": 41
        });*/

        // console.log("dictionnary.cancers_promise",dictionnary.cancers_promise) ; 
        // dictionnary.cancers_promise.push()

        // some hardcoded renaming
        dictionnary.populations_promise = dictionnary.populations_promise
          .map( p => {

            let short_populations_labels = [
              { country : 178 , short_label : 'Congo' },
              { country : 180 , short_label : 'Congo, Dem. People Rep. of' },
              { country : 250 , short_label : 'France' },
              { country : 408 , short_label : 'Korea, Dem. People Rep. of' },
              { country : 418 , short_label : 'Lao People\'s Dem.' },
              { country : 840 , short_label : 'USA' },
              { country : 904 , short_label : 'LAC' },
              { country : 994 , short_label : 'EURO' },
              { country : 992 , short_label : 'PAHO' },
              { country : 996 , short_label : 'WPRO' },
              { country : 995 , short_label : 'SEARO' },
              { country : 993 , short_label : 'EMRO' },
              { country : 991 , short_label : 'AFRO' },
              { country : 748 , short_label : 'Eswatini' , label : 'Eswatini'},
              { country : 792 , short_label : 'Türkiye' , label : 'Türkiye'}
            ] ; 

            let expt = short_populations_labels.find( s => s.country == p.country ) ; 
            
            let label ;  

            if ( expt == undefined )
              label = p.label.replace('country','')  ; 
            else {
              if ( expt.label != undefined ) p.label = expt.label ; 
              label = expt.short_label ;
            }

            p.label = p.label.charAt(0).toUpperCase() + p.label.slice(1);
            p.short_label = label.charAt(0).toUpperCase() + label.slice(1);

            return p ; 
          })
        
        state.dictionnary = dictionnary ; 

        if ( state.const.enable_population_grouping == true )
        {

          let populations = Object.values(state.dictionnary.populations_promise)  ; 

          // apply factsheet 
          /* let groupings = {
            'hdi' : d3.nest().key(d=>d.hdi[2018].group).entries(populations) , 
            'who' : d3.nest().key(d=>d.who_region).entries(populations) , 
            'continents' : d3.nest().key(d=>d.continent).entries(populations) , 
            'income' : d3.nest().key(d=>d.income).entries(populations) , 
            'regions' : d3.nest().key(d=>d.area).entries(populations) , 
            'gicr_hubs' : d3.nest().key(d=>d.hub).entries(populations) 
          } */

          state.const.populations_groupings.forEach(( group_ )=>{
            
            let countries_g = d3.nest()
                .key(d=>{
                  let key_ = d[group_.field] ;
                  //if ( group_.name == 'hdi' ) key_ = d.hdi[2018].group ; 
                  return key_ ; 
                })
                .entries( populations.filter(d=>{
                  let key_ = d[group_.field] ;
                  //if ( group_.name == 'hdi' ) key_ = d.hdi[2018].group ; 
                  return key_ != ''; 
                }))  ;

            // console.log(" group_ ", group_.field , countries_g ) ;

            group_.groups.forEach( ( sub_group )=>{
              let countries = countries_g.find((g)=>{
                // let field = (sub_group.field!=undefined)?sub_group.field:sub_group.id
                return g.key == sub_group.id

              })
              
              if ( countries != undefined ){
                // console.info("sub_group",sub_group.label,countries.values);
                sub_group.countries = countries.values ; 
              }

            }) ;
            
          })

          // console.info("state",state.dictionnary) ; 

          // define sex specific cancers 
          state.dictionnary.cancers_sex_specific = state.dictionnary.cancers_promise.filter( c => c.gender > 0 )

          // state.dictionnary.populations_groupings = groupings ;
          // console.log(" state.dictionnary ", state.dictionnary ) ; 

          // determine colors

        } 

      },
      setFilters(state,filters){
        state.filters = filters 
      },
      setExtraTabs(state,extra_tabs){
        state.extra_tabs = extra_tabs 
      },
      setGraphic(state,graphic){
        state.graphic = graphic 
      },
      toggleRegionalFootnote(state,show){
        state.show_regional_footnote = show ; 
      },
      setGraphicFootnote(state,footenote){ 
        // let footnote_regional = ( state.filters.types == '0_1') ? "* Sub-national incidence data" : "* Sub-national data" ; 
        if ( state.graphic_footnotes.includes( footenote ) == false)
          state.graphic_footnotes.push( footenote ) ; 
      },
      clearGraphicFootnote(state){
        state.show_regional_footnote = false ; 
        state.graphic_footnotes = [] ; 
      }
      
    },
    
    /**
    * Actions
    */
    actions: {
    
    }
})
